import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Brand, BrandName } from '@printdeal/ui-library';

import { SanitizedOrder } from '../../../../../types/order/Order';
import ChangePaymentMethodButton from '../OrderActions/ChangePaymentMethod/ChangePaymentMethodButton';
// @ts-expect-error
import { getPaymentMethod, paymentMethodIds, getMandateId } from '../../../../../helpers/payments/paymentMethods';
// @ts-expect-error
import { messages } from '../../../translations/orders';

import MandateInfo from './MandateInfo';

interface ShowPaymentMethodProps {
  paymentMethod: string;
}

interface OrderPaymentMethodProps {
  order: SanitizedOrder;
}

const ShowPaymentMethod = ({ paymentMethod }: ShowPaymentMethodProps) => {
  if (paymentMethod === paymentMethodIds.creditCard) {
    return (
      <>
        <Brand data-cy="paymentMethodIcon" brand="mastercard" className="pd-inline-block pd-h-10" />
        <Brand data-cy="paymentMethodIcon" brand="visa" className="pd-ml-2 pd-inline-block pd-h-10" />
      </>
    );
  }
  if (paymentMethod === paymentMethodIds.bcmc
    || paymentMethod === paymentMethodIds.bcmc_mobile) {
    return <Brand data-cy="paymentMethodIcon" brand="bancontactmrcash" className="pd-inline-block pd-h-10" />;
  }

  if (paymentMethod !== paymentMethodIds.onAccount && paymentMethod !== paymentMethodIds.mandate) {
    return <Brand data-cy="paymentMethodIcon" brand={paymentMethod as BrandName} className="pd-inline-block pd-h-10" />;
  }

  return messages?.[paymentMethod] && (
    <FormattedMessage id={messages[paymentMethod].id} />
  );
};

const OrderPaymentMethod = ({
  order,
}: OrderPaymentMethodProps) => {
  const { paymentInfo } = order;
  const paymentMethod = paymentInfo ? getPaymentMethod(paymentInfo) : paymentMethodIds.ideal;
  const mandateId = paymentInfo && paymentMethod === 'mandate' ? getMandateId(paymentInfo) : null;

  return (
    <div className="pd-flex pd-gap-x-4">
      <div className="pd-w-48">
        <div className="pd-font-bold">
          <FormattedMessage
            id="account.order.payment.method.title"
            defaultMessage="Payment method name"
          />
        </div>
        <ChangePaymentMethodButton order={order} />
      </div>
      <div className="pd-grow" data-cy="paymentMethodText">
        <ShowPaymentMethod paymentMethod={paymentMethod} />
        {mandateId && <MandateInfo orderId={order.id} mandateId={mandateId} />}
      </div>
    </div>
  );
};

export default OrderPaymentMethod;
